<template>
  <form @submit.prevent="checkValidation()" autocomplete="off">
    <vx-card class="project-detail mt-4 mb-6" :title="$t('labels.personal_details')">
      <div class="vx-col sm:w-full md:w-full lg:w-1/1 d-theme-dark-bg p-0">
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2">
            <label class="font">{{ $t("labels.name") }}</label>
            <vs-input type="text" class="w-full mt-1" name="name" :placeholder="$t('strings.enter_name')"
              icon-pack="feather" icon="icon-user" v-model="name" icon-no-border v-validate="'required|max:50'" />
            <span class="text-danger text-sm">{{ errors.first("name") }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label>{{ $t("labels.email") }}</label>
            <vs-input type="email" class="w-full mt-1" name="email" icon-pack="feather" icon="icon-mail" icon-no-border
              :placeholder="$t('labels.email')" v-model="email" v-validate="'required'" />
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font">{{ $t("labels.nationality") }}</label>
            <v-select multiple v-model="port" :options="port_drop" :reduce="(port_drop) => port_drop"
              label="nationality" name="nationality" :placeholder="$t('strings.select_nationality')" class="mt-1"
              :closeOnSelect="false" />
            <span class="text-danger text-sm">{{
              errors.first("nationality")
              }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font flex items-baseline">{{ $t("labels.date_of_birth") }}
              <i :title="$t('labels.date_placeholder')"
                class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null ml-2 text-primary"></i>
            </label>
            <flat-pickr :config="configFromdateTimePicker" v-model="date_of_birth" class="mt-1" name="date_of_birth"
              icon-pack="feather" icon="icon-calaender" placeholder="Select Date" dateFormat="d-m-Y" inputmode="true"
              @on-change="onFromChange" />
            <span class="text-danger text-sm">{{
              errors.first("date_of_birth")
              }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font">{{ $t("labels.place_of_birth") }}</label>
            <vs-input type="text" class="w-full mt-1" name="place_of_birth" :placeholder="$t('strings.place_of_birth')"
              icon-pack="feather" v-model="place_of_birth" icon-no-border />
            <span class="text-danger text-sm">{{
              errors.first("place_of_birth")
              }}</span>
          </div>
        </div>
        <!--        <div class="vx-row">-->
        <!--          <div class="vx-col sm: w-full md:w-1/2 mt-6">-->
        <!--            <label class="font">{{ $t('labels.nationality') }}</label>-->
        <!--            <v-select-->
        <!--              multiple-->
        <!--              v-model="port"-->
        <!--              :options="port_drop"-->
        <!--              :reduce="port_drop => port_drop"-->
        <!--              label="name"-->
        <!--              name="nationality"-->
        <!--              :placeholder="$t('strings.select_nationality')"-->
        <!--              class="mt-1"-->
        <!--              :closeOnSelect="false"-->
        <!--            />-->
        <!--            <span class="text-danger text-sm">{{ errors.first('nationality') }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </vx-card>
    <vx-card class="project-detail mb-6" :title="$t('labels.address')">
      <div class="vx-col sm:w-full md:w-full lg:w-1/1 d-theme-dark-bg p-0">
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2">
            <label class="font">{{ $t("labels.street1") }}</label>
            <vs-input type="text" class="w-full mt-1" name="street1" :placeholder="$t('strings.enter_street1')"
              icon-pack="feather" icon="icon-user" v-model="street1" icon-no-border />
            <span class="text-danger text-sm">{{
              errors.first("street1")
              }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0">
            <label class="font">{{ $t("labels.street2") }}</label>

            <vs-input type="text" class="w-full mt-1" name="street2" :placeholder="$t('strings.enter_street2')"
              icon-pack="feather" icon="icon-user" v-model="street2" icon-no-border />
            <span class="text-danger text-sm">{{
              errors.first("street2")
              }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font">{{ $t("labels.city") }}</label>
            <vs-input type="text" class="w-full mt-1" name="city" :placeholder="$t('strings.enter_city')"
              icon-pack="feather" icon="icon-user" v-model="city" icon-no-border />
            <span class="text-danger text-sm">{{ errors.first("city") }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label>{{ $t("labels.country") }}</label>
            <v-select class="w-full mt-1" v-model="country" :options="countries"
              :placeholder="$t('strings.select_country')" name="country" :reduce="(country) => country.id"
              label="name" />
            <span class="text-danger text-sm">{{
              errors.first("country")
              }}</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font">{{ $t("labels.postal_code") }}</label>
            <vs-input type="text" class="w-full mt-1" name="postal_code" :placeholder="$t('strings.enter_postal_code')"
              icon-pack="feather" icon="icon-user" v-model="postal_code" icon-no-border />
            <span class="text-danger anger text-sm">{{
              errors.first("postal_code")
              }}</span>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="project-detail mb-6" :title="$t('labels.current_status')">
      <div class="vx-col sm:w-full md:w-full lg:w-1/1 d-theme-dark-bg p-0">
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2">
            <label class="font">{{ $t("labels.rank") }}</label>
            <vs-input type="text" class="w-full mt-1" name="rank" :placeholder="$t('strings.enter_rank')"
              icon-pack="feather" icon="icon-user" v-model="rank_status" icon-no-border />
            <span class="text-danger text-sm">{{ errors.first("rank") }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0">
            <label class="font flex items-baseline">{{ $t("labels.date_of_joining") }}
              <i :title="$t('labels.date_placeholder')"
                class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null ml-2 text-primary"></i>
            </label>
            <flat-pickr :config="configdateTimePicker" v-model="date_of_joining" class="mt-1" name="date_of_joining"
              placeholder="Select Date" inputmode="true" />
            <span class="text-danger text-sm">{{
              errors.first("date_of_joining")
              }}</span>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="project-detail mb-6" :title="$t('labels.contact_information')">
      <div class="vx-col sm:w-full md:w-full lg:w-1/1 d-theme-dark-bg p-0">
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2">
            <label class="font">{{ $t("labels.work_number") }}</label>
            <vue-tel-input v-model="work_mobile_number" v-bind="dropdownOptions" class="mt-1"
              @input="handleInput('work_mobile_number', $event)"></vue-tel-input>
            <span class="text-danger text-sm">{{
              errors.first("work_mobile_number")
              }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0">
            <label class="font">{{ $t("labels.home_number") }}</label>
            <!-- <vs-input
              type="number"
              class="w-full mt-1"
              name="home_telephone_number"
              :placeholder="$t('strings.enter_home_number')"
              icon-pack="feather"
              icon="icon-phone"
              v-model="home_telephone_number"
              icon-no-border
            /> -->
            <vue-tel-input v-model="home_telephone_number" v-bind="dropdownOptions" class="mt-1"
              @input="handleInput('home_telephone_number', $event)"></vue-tel-input>
            <span class="text-danger text-sm">{{
              errors.first("home_telephone_number")
              }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font">{{ $t("labels.alternate_number") }}</label>
            <!-- <vs-input
              type="number"
              class="w-full mt-1"
              name="alternate_mobile_number"
              :placeholder="$t('strings.enter_alternate_number')"
              icon-pack="feather"
              icon="icon-phone"
              v-model="alternate_mobile_number"
              icon-no-border
            /> -->
            <vue-tel-input v-model="alternate_mobile_number" v-bind="dropdownOptions" class="mt-1"
              @input="handleInput('alternate_mobile_number', $event)"></vue-tel-input>
            <span class="text-danger text-sm">{{
              errors.first("alternate_mobile_number")
              }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font">{{ $t("labels.home_email") }}</label>
            <vs-input type="email" class="w-full mt-1" name="home_email_address"
              :placeholder="$t('strings.enter_home_email')" icon-pack="feather" icon="icon-mail"
              v-model="home_email_address" icon-no-border />
            <span class="text-danger text-sm">{{
              errors.first("home_email_address")
              }}</span>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="project-detail" :title="$t('labels.kin_details')">
      <div class="vx-col sm:w-full md:w-full lg:w-1/1 d-theme-dark-bg p-0">
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2">
            <label class="font">{{ $t("labels.kin_contact_name") }}</label>
            <vs-input type="text" class="w-full mt-1" name="contact_name"
              :placeholder="$t('strings.enter_contact_name')" icon-pack="feather" icon="icon-user"
              v-model="kin_contact_name" icon-no-border />
            <span class="text-danger text-sm">{{
              errors.first("contact_name")
              }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0">
            <label class="font">{{ $t("labels.kin_mobile_number") }}</label>
            <!-- <vs-input
              type="number"
              class="w-full mt-1"
              name="mobile_number"
              :placeholder="$t('strings.enter_mobile_number')"
              icon-pack="feather"
              icon="icon-phone"
              v-model="kin_mobile_number"
              icon-no-border
            /> -->
            <vue-tel-input v-model="kin_mobile_number" v-bind="dropdownOptions" class="mt-1"
              @input="handleInput('kin_mobile_number', $event)"></vue-tel-input>
            <span class="text-danger text-sm">{{
              errors.first("mobile_number")
              }}</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font">{{ $t("labels.alternate_number") }}</label>

            <!-- <vs-input
              type="number"
              class="w-full mt-1"
              name="kin_alternate_number"
              :placeholder="$t('strings.enter_alternate_mobile_number')"
              icon-pack="feather"
              icon="icon-phone"
              v-model="kin_alternate_number"
              icon-no-border
            /> -->
            <vue-tel-input v-model="kin_alternate_number" v-bind="dropdownOptions" class="mt-1"
              @input="handleInput('kin_alternate_number', $event)"></vue-tel-input>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mt-6">
            <label class="font">{{ $t("labels.kin_email_address") }}</label>
            <vs-input type="email" class="w-full mt-1" name="email" :placeholder="$t('strings.enter_email')"
              icon-pack="feather" icon="icon-mail" v-model="kin_email_address" icon-no-border />
            <span class="text-danger text-sm">{{ errors.first("email") }}</span>
          </div>
        </div>
      </div>
    </vx-card>

    <div class="vx-row mt-6">
      <div class="vx-col w-full p-0">
        <div class="flex justify-center mt-2">
          <vs-button
            class="vs-component vs-button md:w-auto mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
            button="submit" :disabled="button_loading" id="update-profile">{{ $t("labels.add_user") }}</vs-button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import _ from "lodash";

export default {
  props: ["userId"],
  data() {
    return {
      name: "",
      email: "",
      type: "",
      date_of_birth: null,
      place_of_birth: null,
      nationality: "",
      rank_status: "",
      date_of_joining: null,
      street1: "",
      street2: "",
      city: "",
      postal_code: "",
      work_mobile_number: "",
      home_telephone_number: "",
      alternate_mobile_number: "",
      home_email_address: "",
      kin_contact_name: "",
      kin_mobile_number: "",
      kin_alternate_number: "",
      kin_email_address: "",
      date: null,
      country: "",
      countries: [],
      configdateTimePicker: {
        maxDate: null,
        altFormat: "d-M-Y",
        allowInput: true,
        dateFormat: "d-M-Y",
      },
      configFromdateTimePicker: {
        minDate: null,
        maxDate: new Date(),
        altFormat: "d-M-Y",
        allowInput: true,
        dateFormat: "d-M-Y",
      },
      configTodateTimePicker: {
        minDate: null,
        altFormat: "d-M-Y",
        allowInput: true,
        dateFormat: "d-M-Y",
      },
      port: [],
      port_drop: [],
      dropdownOptions: {
        mode: "international",
        showDialCodeInList: true,
        showDialCodeInSelection: true,
        showFlags: true,
        showSearchBox: true,
        autoFormat: true,
      },
    };
  },
  components: {
    flatPickr,
    moment,
  },
  watch: {
    $route(to, from) { },
  },
  mounted() {
    this.setValidationMessage();
    this.getPorts();
    if (this.$route.name === "EditProfile" || this.$route.name === "EditUser") {
      //    this.getUserProfile();
    }
    //  this.setProfile();
    this.getCountries();
    this.$store.commit("UPDATE_TAB", 1);
  },
  methods: {
    handleInput(field, value) {
      const numericValue = value.replace(/[^0-9+]/g, "");
      this.$nextTick(() => {
        this[field] = numericValue;
      });
    },
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateProfile();
        }
      });
    },
    async getCountries() {
      let response = await this.getHTTPPostResponse("/country/list");
      if (response) {
        let data = response.data;
        let countries = data.countries;
        this.countries = countries;
      }
    },
    async getUserProfile() {
      let consultantId = "";
      if (this.$store.state.userInfo.type === "A") {
        consultantId = this.$route.params.id;
      } else {
        consultantId = this.$store.state.userInfo.id;
      }
      let response = await this.getHTTPGetResponse(
        "/users/get/" + consultantId
      );
      if (response) {
        let user = response.data.user;
        let consultant = user.consultant_detail;
        this.name = user.name;
        this.email = user.email;
        this.type = user.type;
        this.date_of_birth = consultant.date_of_birth;
        this.place_of_birth = consultant.place_of_birth;
        this.rank_status = consultant.rank_status;
        this.date_of_joining = consultant.date_of_joining;
        this.street1 = consultant.street1;
        this.street2 = consultant.street2;
        this.city = consultant.city;
        this.country = consultant.country;
        this.postal_code = consultant.postal_code;
        this.work_mobile_number = consultant.work_mobile_number.replace(
          " ",
          ""
        );
        this.home_telephone_number = consultant.home_telephone_number.replace(
          " ",
          ""
        );
        this.alternate_mobile_number = consultant.alternate_mobile_number;
        this.home_email_address = consultant.home_email_address;
        this.kin_contact_name = consultant.kin_contact_name;
        this.kin_mobile_number = consultant.kin_mobile_number;
        this.kin_alternate_number = consultant.kin_alternate_number;
        this.kin_email_address = consultant.kin_email_address;
        let consultant_nationality = consultant.nationalities;
        this.port = consultant_nationality;
      }
    },
    async setProfile() {
      let p = this.$store.state.userInfo;
      this.name = p.name;
      this.email = p.email;
      this.type = p.type;
      this.subtype = p.subtype;
      this.role_id = p.role_id;
    },
    async getPorts() {
      var input = {
        name: this.port,
      };
      let response = await this.getHTTPPostResponse("/country/list", input);
      if (response) {
        let data = response.data;
        let ports = data.countries;
        this.port_drop = ports;
      }
    },
    // Update Profile Integration API
    async updateProfile() {
      let nationality = [];
      this.port.forEach((element) => {
        nationality.push(element.id);
      });
      let input = {
        name: this.name,
        email: this.email,
        type: "CN",
        place_of_birth: this.place_of_birth,
        nationality: nationality,
        rank_status: this.rank_status,
        date_of_joining: this.date_of_joining,
        street1: this.street1,
        street2: this.street2,
        city: this.city,
        country: this.country,
        postal_code: this.postal_code,
        work_mobile_number: this.work_mobile_number,
        home_telephone_number: this.home_telephone_number,
        alternate_mobile_number: this.alternate_mobile_number,
        home_email_address: this.home_email_address,
        kin_contact_name: this.kin_contact_name,
        kin_mobile_number: this.kin_mobile_number,
        kin_alternate_number: this.kin_alternate_number,
        kin_email_address: this.kin_email_address,
      };
      if (this.date_of_birth) {
        input = Object.assign(
          {
            date_of_birth: moment(this.date_of_birth).format("Y-M-DD"),
          },
          input
        );
      }
      let consultantId = "";
      if (this.$store.state.userInfo.type === "A") {
        consultantId = this.$route.params.id;
      } else {
        consultantId = this.$store.state.userInfo.id;
      }
      let response = await this.getHTTPPostResponse(
        "/users/create",
        input,
        "#update-profile",
        true
      );
      if (response) {
        this.$store.commit("UPDATE_TAB", 2);
        this.$router.push({ name: "Users" });
      }
    },
    goBack() {
      history.back();
    },
  },
};
</script>
<style scoped>
button.login-btn {
  background: rgba(var(--vs-primary), 1) !important;
}

.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
</style>
